import { createSelector } from 'reselect';

import { getState } from '../rootSelector';

export const getActiveRecommendedSeats = createSelector(getState, state => state.activeRecommendedSeats);
